"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rolesList = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formWrapper = _interopRequireDefault(require("../formWrapper.js"));
var _index = _interopRequireDefault(require("./Footer/index.js"));
var _index2 = _interopRequireDefault(require("./ActivationEmails/index.js"));
var _window, _window$cccisd, _window$cccisd$appDef, _window$cccisd$appDef2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var appDefsRoles = ((_window = window) === null || _window === void 0 ? void 0 : (_window$cccisd = _window.cccisd) === null || _window$cccisd === void 0 ? void 0 : (_window$cccisd$appDef = _window$cccisd.appDefs) === null || _window$cccisd$appDef === void 0 ? void 0 : (_window$cccisd$appDef2 = _window$cccisd$appDef.pawn) === null || _window$cccisd$appDef2 === void 0 ? void 0 : _window$cccisd$appDef2.roles) || [];
var ignoredRoleHandles = ['metricspawn', 'respondent'];
var rolesList = exports.rolesList = appDefsRoles.filter(function (role) {
  return !ignoredRoleHandles.includes(role.handle);
});
var allRolesActivationEmailFields = rolesList.reduce(function (res, role) {
  res.push("siteContent.".concat(role.handle, ".activationEmail.subject"));
  res.push("siteContent.".concat(role.handle, ".activationEmail.body"));
  return res;
}, []);
var fields = ['footer.backgroundColor', 'footer.copyrightAttribution', 'footer.copyrightYear', 'footer.grantAttribution', 'footer.showPolicyLinks', 'footer.showContactUsLink', 'footer.showTermsAndConditionsLink', 'footer.showPrivacyPolicyLink', 'footer.contactUsLink', 'footer.termsLink', 'footer.policyLink', 'siteContent.activationEmail.subject', 'siteContent.activationEmail.body'].concat(_toConsumableArray(allRolesActivationEmailFields));
var footerInitialValues = {
  backgroundColor: '#F8F8F8',
  copyrightAttribution: '',
  copyrightYear: '',
  grantAttribution: '',
  showPolicyLinks: true,
  showContactUsLink: true,
  showTermsAndConditionsLink: true,
  showPrivacyPolicyLink: true,
  contactUsLink: '',
  termsLink: '',
  policyLink: ''
};
var emailInitialValues = {
  subject: 'User Registration Site Access',
  body: '<p>Use the link below to register for site access</p>'
};
var Form = function Form(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'grid',
      rowGap: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_index2["default"], _extends({}, props, {
    initialValues: emailInitialValues
  })), /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, props, {
    initialValues: footerInitialValues
  })));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields
})(Form);